import { Wordmark } from './Wordmark';
import type { HubUser } from '../lib/auth';

type Props = {
  tone?: 'cream' | 'dark';
  user?: HubUser | null;
  onMenu?: () => void;
};

export function TopBar({ tone = 'cream', user, onMenu }: Props) {
  const onDark = tone === 'dark';
  const color = onDark ? '#fff' : 'var(--ink)';
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 10,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: '28px 36px',
        color,
      }}
    >
      <Wordmark size={18} color={color} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        {user && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 13, opacity: 0.8 }}>{user.name}</span>
            {user.photoUrl ? (
              <img
                src={user.photoUrl}
                alt=""
                referrerPolicy="no-referrer"
                className="avatar"
                style={{ objectFit: 'cover' }}
              />
            ) : (
              <div
                className="avatar"
                style={{
                  background: onDark ? '#fff' : 'var(--ink)',
                  color: onDark ? 'var(--ink)' : '#fff',
                }}
              >
                {user.initials}
              </div>
            )}
          </div>
        )}
        <button className="burger" onClick={onMenu} aria-label="Menu" style={{ color }}>
          <span />
        </button>
      </div>
    </div>
  );
}
